import AssetDataTable from 'src/components/section/AssetDataTable';
import CardWrapper from 'src/components/util/CardWrapper';
import InstructionsList from 'src/components/InstructionsList';
import { Typography } from '@mui/material';

const AssetPage = () => {
  const instructions = [
    {
      label: 'To add an asset:',
      description: 'click "Add Asset," enter details, then "Confirm and Save."',
    },
    {
      label: 'To edit an asset:',
      description: 'click its row, make changes, then "Confirm and Save."',
    },
    {
      label: 'To fix an accidental delete:',
      description: 'click "Add Asset" and re-enter the item details.',
    },
  ];

  return (
    <>
      <CardWrapper>
        <InstructionsList instructions={instructions} />
        <Typography sx={{ fontWeight: 'bold', marginTop: 1 }}>
          An equipment list is required in order to qualify for an exemption.
        </Typography>
        <Typography sx={{ fontStyle: 'italic', marginTop: 1 }}>
          * Please note – if your excel spreadsheet is larger than 100 line items, please send a
          duplicate copy with the account number to personalproperty@utahcounty.gov
        </Typography>
      </CardWrapper>

      <AssetDataTable />
    </>
  );
};

export default AssetPage;
